import { MULTI_FORM_ACTIONS } from '../../../constants/workflow.constant';

export const initialState = {
  forms: [],
  activeFormIndex: 0,
  activeSubformIndex: 0,
  formData: {},
  loading: true,
  error: null,
  submitting: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case MULTI_FORM_ACTIONS.SET_FORMS:
      return {
        ...state,
        forms: action.forms,
        loading: false,
        formData: action.formData || {},
      };
    case MULTI_FORM_ACTIONS.SET_ACTIVE_FORM:
      return {
        ...state,
        activeFormIndex: action.index,
        activeSubformIndex: 0,
      };
    case MULTI_FORM_ACTIONS.SET_ACTIVE_SUBFORM:
      return {
        ...state,
        activeSubformIndex: action.index,
      };
    case MULTI_FORM_ACTIONS.UPDATE_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.formId]: {
            ...(state.formData[action.formId] || {}),
            ...action.data,
          },
        },
      };
    case MULTI_FORM_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        submitting: action.submitting || false,
      };
    case MULTI_FORM_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        submitting: false,
      };
    case MULTI_FORM_ACTIONS.RESET:
      return { ...initialState };
    default:
      return state;
  }
};
